export default function contentCopyByNameInput(name) {
  const copyText: any = document.getElementById(name);
  copyText.select();
  copyText.setSelectionRange(0, 200);
  document.execCommand('copy');
}